module.exports = __webpack_public_path__ + "static/media/proximanova-bold-webfont.7c1f8427.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/resources/fonts/proximanova-bold-webfont.ttf
// module id = 368
// module chunks = 0